import React, { useContext, useEffect, useRef, useState } from "react";
import { isIOS } from "react-device-detect";
import { AudioAppContext } from "../../../contexts/AudioContext";
import { setCSSVar } from "../../../util/colorUtil";
import useElementHeight from "../../hooks/useElementHeight";
import {
  isMobileOrTablet,
  isMobileClass,
} from "../../Views/MobileClassRenderer";
import ButtonClickToUnmute from "./ButtonClickToUnmute";

export default function BackgroundVideoPlayerMobileView({
  handleOnEnd,
  navigateToPageOnVideoEnd,
  source,
}) {
  const videoRef = useRef(null);
  const wrapperRef = useRef(null);
  const [wrapperHeight, recomputeHeight] = useElementHeight(wrapperRef, [
    videoRef,
  ]);

  const { videoMuted, setVideoMuted } = useContext(AudioAppContext)

  useEffect(() => {
    if (typeof wrapperHeight === "number")
      setCSSVar("video-height", `${wrapperHeight}px`);
  }, [wrapperHeight]);

  return (
    <div ref={wrapperRef} style={{ position: "relative", height: "auto" }}>
      <ButtonClickToUnmute />
      <video
        ref={videoRef}
        id="backgroundVideo"
        onEnded={handleOnEnd}
        className={isMobileClass("video")}
        onTouchStart={() => {
          setTimeout(() => {
            setVideoMuted(!videoMuted);
          }, 200);
          setTimeout(() => {
            const videoElem = videoRef?.current;
            if (!videoElem) return;

            if (isIOS) {
              videoElem.webkitEnterFullscreen();
            } else {
              videoElem.requestFullscreen();
            }
          }, 200);
        }}
        style={{
          height: "auto",
          zIndex: 100,
        }}
        playsInline
        loop={navigateToPageOnVideoEnd ? false : true}
        muted={videoMuted}
        autoPlay
      >
        <source src={source} type="video/mp4" />
      </video>
    </div>
  );
}
